const stages = [
    {key: 'attention', label: 'Требуют решения', tone: 'danger'},
    {key: 'returned', label: 'На доработке', tone: 'warning'},
    {key: 'missing', label: 'Не поданы', tone: 'warning'},
    {key: 'submitted', label: 'На проверке', tone: 'primary'},
    {key: 'ready', label: 'Готовы', tone: 'success'},
    {key: 'empty', label: 'Без данных для расчёта', tone: 'quiet'},
    {key: 'excluded', label: 'Исключены из комплекта', tone: 'quiet'}
].map((stage, priority) => ({...stage, priority, actionable: priority < 4}));

function priority(item) {
    if (item.excluded_by_settings) return 6;
    if (item.required_submission_missing || item.needs_package_decision || item.package_decision_stale) return 0;
    if (item.excluded_by_review) return 6;
    if (item.ignored_empty || item.status === 'no_data') return item.blockers && item.blockers.length ? 0 : 5;
    if (item.report_reconciliation && item.report_reconciliation.required && item.report_reconciliation.matches === false) return 0;
    if (['returned', 'hr_editing'].includes(item.status)) return 1;
    if (['missing', 'not_created', 'draft'].includes(item.status)) return 2;
    if (item.status === 'submitted') return 3;
    if (['approved', 'historical_locked'].includes(item.status)) return item.blockers && item.blockers.length ? 0 : 4;
    return 0;
}

function statusKey(item) {
    return item.excluded_by_settings ? 'excluded' : item.excluded_by_review ? 'excluded_by_review' : item.status;
}

function groupObjects(items, {search = '', status = '', onlyActionable = false} = {}) {
    const query = search.trim().toLocaleLowerCase('ru');
    const groups = new Map();
    items.forEach(item => {
        if (query && !String(item.object_name || '').toLocaleLowerCase('ru').includes(query)) return;
        if (status && statusKey(item) !== status) return;
        if (!groups.has(item.building_id)) groups.set(item.building_id, {...item, items: []});
        groups.get(item.building_id).items.push(item);
    });
    const compareName = (a, b) => String(a || '').localeCompare(String(b || ''), 'ru', {numeric: true, sensitivity: 'base'});
    return Array.from(groups.values()).map(group => {
        group.items.sort((a, b) => priority(a) - priority(b) || compareName(a.name, b.name) || (a.timesheet_id || 0) - (b.timesheet_id || 0));
        group.readiness = stages[priority(group.items[0])];
        return group;
    }).filter(group => !onlyActionable || group.readiness.actionable).sort((a, b) =>
        a.readiness.priority - b.readiness.priority || compareName(a.object_name, b.object_name) || a.building_id - b.building_id);
}

function sections(groups, historical = false) {
    return stages.map(stage => ({...stage, label: historical && stage.key === 'ready' ? 'Сохранённые табели' : stage.label,
        groups: groups.filter(group => group.readiness.key === stage.key)})).filter(section => section.groups.length);
}

module.exports = {stages, priority, statusKey, groupObjects, sections};
